import React from 'react';
import Translator from '../../../core/i18n';
import { Modal } from 'reactstrap';
import { Document, Page, pdfjs } from 'react-pdf';
import { Common } from '../../../core/common';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Button } from '../../ui-elements/main';
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const T = Translator.create();
let _common: Common;

interface IPdfPreviewPorps {
    modalIsOpen: boolean,
    setCloseModal: () => void,
    selectedFile: {
        name: string,
        path: string
    }
}

class PdfPreview extends React.Component<IPdfPreviewPorps, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            pageNumber: 1,
            numPages: 0,
            isLoading: true,
            fileLink: ""
        };
        _common = new Common();
    }

    componentDidMount(): void {
        if (this.props.selectedFile) {
            this.previewLink(this.props.selectedFile.path);
        }
    }

    componentDidUpdate(prevProps: Readonly<IPdfPreviewPorps>, prevState: Readonly<any>, snapshot?: any): void {
        if (prevProps.selectedFile !== this.props.selectedFile && this.props.selectedFile) {
            this.setState({ isLoading: true });
            this.previewLink(this.props.selectedFile.path);
        }
    }

    previewLink = async (path: string) => {
        if (path) {
            try {
                const file = await _common.PreviewLink(path);
                if (file) {
                    this.setState({ fileLink: file, isLoading: false });
                }
            } catch (error) {
                console.error("Dosya önizlemesinde hata oluştu:", error);
            }
        }
    }

    public clickToDownload = async () => {
        const { path, name } = this.props.selectedFile;
        if (path && name) {
            await _common.DownloadLink(path + '/download', name);
        }
    };

    onDocumentLoadSuccess = ({ numPages }: { numPages: number }): void => {
        this.setState({ numPages, isLoading: false });
    };

    onPageLoadStart = () => {
        this.setState({ isLoading: true });
    };

    onPageLoadError = (error: any) => {
        this.setState({ isLoading: false });
    };

    onPageLoadSuccess = () => {
        this.setState({ isLoading: false });
    };

    goToPrevPage = () => {
        this.onPageLoadStart();
        this.setState((prevState: any) => ({
            pageNumber: Math.max(prevState.pageNumber - 1, 1),
        }));
        this.setState({ isLoading: false });
    };

    goToNextPage = () => {
        this.onPageLoadStart();
        this.setState((prevState: any) => ({
            pageNumber: Math.min(prevState.pageNumber + 1, prevState.numPages),
        }));
        this.setState({ isLoading: false });
    };

    public render() {
        const { numPages, pageNumber, isLoading } = this.state;
        const { selectedFile } = this.props;
        return (
            <Modal
                className="privew-modal exam-modal-stats"
                isOpen={this.props.modalIsOpen}
                toggle={this.props.setCloseModal}
                style={{ minWidth: "fit-content" }}
            >
                <div className="modal-header border-0 d-flex justify-content-between mb-2 mb-md-0">
                    <h6 className="modal-title d-inline-flex align-items-center" id="exampleModalLabel">
                        &nbsp;
                        {selectedFile.name}
                    </h6>
                    <button type="button" className="close p-0" style={{ marginInlineEnd: "0px" }} onClick={this.props.setCloseModal} aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body min-height-75 d-flex justify-content-center align-items-center">
                    {isLoading
                        ?
                        <div>
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                        :
                        <Document
                            className="h-inherit"
                            file={this.state.fileLink}
                            onLoadSuccess={this.onDocumentLoadSuccess}
                            onLoadError={this.onPageLoadError}
                            options={{
                                cMapUrl: 'https://unpkg.com/pdfjs-dist@2.5.207/cmaps/',
                                cMapPacked: true,
                            }}
                            error={T.t('r_pdf_upload_error')}
                        >
                            <Page
                                renderTextLayer={true}
                                className="h-inherit"
                                pageNumber={pageNumber}
                                onLoadSuccess={this.onPageLoadSuccess}
                                onLoadError={this.onPageLoadError}
                            />
                        </Document>
                    }
                </div>
                <div className="modal-footer">
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>

                        <Button
                                    button_type='secondary'
                                    iconPosition='left'
                                    materialicon='cloud_download'
                                    size='small'
                                    text={T.t('r_download')}
                                    onClick={this.clickToDownload}
                                />
                        <p>
                            {T.t('r_page')} {pageNumber} / {numPages}
                        </p>
                        <div className='d-flex gap-1'>
                            <button onClick={this.goToPrevPage} disabled={pageNumber <= 1} className="category-tag-square tag-gray" >
                                <span className="material-icons">
                                    arrow_back
                                </span>
                            </button>
                            <button onClick={this.goToNextPage} disabled={pageNumber >= numPages} className="category-tag-square tag-green">
                                <span className="material-icons">
                                    arrow_forward
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default PdfPreview;
